<template>
  <div>
    <el-tree
    :disabled="disabled"
    :data="dicData" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
  </div>
</template>

<script>
export default {
  props: ['column', 'scope'],
  data() {
    const {
      dicData,
      disabled
    } = this.column
    return {
      disabled: !!disabled,
      dicData,
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    }
  },
  methods: {
    handleNodeClick(data) {
      this.$emit('on-edit', data.value, this.column.prop, this.scope.$index)
    }
  }
}
</script>
